import { Seo } from "../components/Seo";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { BUSINESS } from "../content";

const SECTIONS = [
  {
    title: "What we collect",
    body: "When you submit an enquiry through this website, we collect the details you provide — such as your name, phone number, email address, suburb and information about your property and cleaning requirements. We collect this information so we can respond to your enquiry and provide you with a quote.",
  },
  {
    title: "How we use your information",
    body: "Your information is used only to respond to your enquiry, arrange quotes and provide cleaning services. We do not sell, rent or share your personal information with third parties for their marketing purposes.",
  },
  {
    title: "Storage & security",
    body: "Enquiry details are stored securely and accessed only to respond to your request. We take reasonable steps to protect your personal information from misuse, loss and unauthorised access.",
  },
  {
    title: "Cookies & analytics",
    body: "This website does not set advertising or tracking cookies by default. If analytics tools are added in future, this policy will be updated to describe what is collected and why.",
  },
  {
    title: "Access & correction",
    body: "You can ask us at any time to access, correct or delete the personal information we hold about you. Simply contact us using the details below.",
  },
  {
    title: "Contact",
    body: `If you have any questions about this policy or how your information is handled, contact ${BUSINESS.name} on ${BUSINESS.phone} or via our Facebook page.`,
  },
];

export const PrivacyPage = () => (
  <>
    <Seo
      title="Privacy Policy | Pure Bliss Clean"
      description={`How ${BUSINESS.name} collects, uses and protects your personal information.`}
      path="/privacy-policy"
    />
    <PageHero
      eyebrow="Privacy"
      titleLines={["Privacy Policy"]}
      intro="We only collect the information needed to respond to your enquiry and provide you with a quote. Here's how it's handled."
    />
    <section className="mx-auto max-w-3xl px-6 py-20 lg:py-28">
      <div className="space-y-10">
        {SECTIONS.map((s, i) => (
          <Reveal key={s.title} delay={0.05 * i}>
            <h2 className="font-display text-xl font-bold text-brand-ink">{s.title}</h2>
            <p className="mt-3 text-sm leading-relaxed text-slate-600">{s.body}</p>
          </Reveal>
        ))}
        <Reveal delay={0.3}>
          <p className="text-xs text-slate-400">Last updated: July 2026</p>
        </Reveal>
      </div>
    </section>
  </>
);
